export const handleKeyDownEnter = (e: React.KeyboardEvent<HTMLInputElement>, callback: () => void) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    callback();
  }
};
